import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../../../formInputsV2/styles/tokens';

// Page-level secondary actions (Consulenza Report, Contatta il Backoffice) —
// deliberately their own family, not the form PrimaryButton/SecondaryButton
// (those are for the one prominent action on a form step) and not
// ModificaButton (that shape is reserved for "edit this data" so it isn't
// confused with these). Shares ModificaButton's size scale/radius/font so it
// still reads as part of the same v2 language.
// Staying content-width (never stretched full-width, even stacked on
// mobile) is deliberate: a full-width block sitting in a column of cards
// just reads as another card, regardless of radius. Auto-width is what
// actually signals "control," not "container."
const base = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-shrink: 0;
  width: fit-content;
  padding: 9px 18px;
  border-radius: 10px;
  font-family: ${v2FontFamily};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;

  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }
`;

// Tonal brand fill — for actions that reveal/toggle something in place
// (Consulenza Report). Light wash of the brand green rather than a full
// solid fill, so it doesn't compete with Procedi's solid green CTA.
export const TonalActionButton = styled.button`
  ${base}
  border: 1px solid ${v2Colors.primaryBorder};
  background: ${v2Colors.primarySoft};
  color: ${v2Colors.primary};

  &:hover,
  &:focus-visible {
    background: ${v2Colors.primarySoftHover};
  }

  @media (max-width: ${v2Breakpoints.tablet}) {
    padding: 8px 14px;
    font-size: 12.5px;
  }
`;

// Tonal blue — for actions that leave the page/open something separate
// (Contatta il Backoffice). Its own component so it can carry a different
// icon and never be mistaken for an edit action; blue keeps it distinct from
// the green Procedi/Consulenza buttons and the red count badge.
export const OutlineActionButton = styled.button`
  ${base}
  position: relative;
  border: 1px solid ${v2Colors.infoBorder};
  background: ${v2Colors.infoSoft};
  color: ${v2Colors.info};

  &:hover,
  &:focus-visible {
    background: ${v2Colors.infoSoftHover};
  }

  @media (max-width: ${v2Breakpoints.tablet}) {
    padding: 8px 14px;
    font-size: 12.5px;
  }
`;

// Replaces the old nested Bootstrap flex/breakpoint divs (which only
// switched orientation at Bootstrap's xxl breakpoint and didn't wrap) with
// a single row that wraps at the same v2Breakpoints.tablet cutoff the rest
// of the redesign uses. Buttons stay content-width and simply wrap onto a
// second line on narrow screens, rather than stacking as full-width blocks
// — see SecondaryActionButtons.styles.js base comment.
export const ActionButtonsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$spread ? 'space-between' : 'flex-end')};
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  margin-top: 8px;
`;

export const ActionButtonBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 999px;
  background: ${v2Colors.danger};
  color: #fff;
  font-family: ${v2FontFamily};
  font-size: 10.5px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;
